const COLOR = {
  blue:   { border: 'border-slate-200', header: 'bg-indigo-600',  bg: 'bg-white' },
  teal:   { border: 'border-slate-200', header: 'bg-teal-600',    bg: 'bg-white' },
  green:  { border: 'border-slate-200', header: 'bg-emerald-600', bg: 'bg-white' },
  yellow: { border: 'border-slate-200', header: 'bg-amber-500',   bg: 'bg-white' },
};

const TOOLS = [
  {
    tool: 'Google ドキュメント', icon: '📝', color: 'blue',
    shortcuts: [
      { action: 'リンクを挿入',      win: 'Ctrl + K',         mac: '⌘ + K'         },
      { action: '書式なし貼り付け',  win: 'Ctrl + Shift + V', mac: '⌘ + Shift + V' },
      { action: '文字数カウント',    win: 'Ctrl + Shift + C', mac: '⌘ + Shift + C' },
    ],
  },
  {
    tool: 'Google スプレッドシート', icon: '📊', color: 'green',
    shortcuts: [
      { action: '今日の日付を入力', win: 'Ctrl + ;',         mac: '⌘ + ;'           },
      { action: 'セル内改行',       win: 'Alt + Enter',      mac: 'Option + Enter'  },
      { action: '値のみ貼り付け',   win: 'Ctrl + Shift + V', mac: '⌘ + Shift + V'  },
    ],
  },
  {
    tool: 'Google スライド', icon: '📽️', color: 'yellow',
    shortcuts: [
      { action: 'スライド・図形を複製', win: 'Ctrl + D', mac: '⌘ + D' },
      { action: 'レーザーポインター',   win: 'Ctrl + L', mac: '⌘ + L' },
    ],
  },
  {
    tool: 'Gmail', icon: '✉️', color: 'teal',
    note: '設定画面から「ショートカット ON」にする必要があります',
    shortcuts: [
      { action: '新規作成', win: 'C',            mac: 'C'           },
      { action: '送信',     win: 'Ctrl + Enter', mac: '⌘ + Enter'  },
    ],
  },
  {
    tool: 'Google カレンダー', icon: '📅', color: 'green',
    note: '設定画面から「ショートカット ON」にする必要があります',
    shortcuts: [
      { action: '今日 (Today) に戻る', win: 'T',        mac: 'T'        },
      { action: '表示切替 (日/週/月)', win: 'D / W / M', mac: 'D / W / M' },
    ],
  },
  {
    tool: 'Google Meet', icon: '🎥', color: 'blue',
    note: '画面がアクティブ（クリックした状態）でないと反応しません',
    shortcuts: [
      { action: 'マイクのON / OFF',        win: 'Ctrl + D',       mac: '⌘ + D'           },
      { action: 'カメラのON / OFF',        win: 'Ctrl + E',       mac: '⌘ + E'           },
      { action: '挙手',                    win: 'Ctrl + Alt + H', mac: '⌘ + Control + H' },
      { action: 'チャットの表示 / 非表示', win: 'Ctrl + Alt + C', mac: '⌘ + Control + C' },
      { action: '参加者の表示 / 非表示',   win: 'Ctrl + Alt + P', mac: '⌘ + Control + P' },
    ],
  },
];

function Kbd({ children }) {
  return (
    <kbd className="sc-kbd text-[11px] font-mono bg-slate-100 border border-slate-200 border-b-2 text-slate-600 px-1.5 py-0.5 rounded-md w-28 text-center block whitespace-nowrap shadow-sm">
      {children}
    </kbd>
  );
}

function ToolCard({ tool, icon, color, shortcuts, note }) {
  const c = COLOR[color] || COLOR.blue;
  return (
    <div className={`sc-card rounded-2xl border ${c.border} bg-white shadow-card overflow-hidden break-inside-avoid`}>
      <div className={`sc-card-head ${c.header} px-4 py-3 flex items-center gap-2`}>
        <span className="sc-icon text-base leading-none">{icon}</span>
        <h3 className="text-white font-bold text-sm">{tool}</h3>
      </div>

      {note && (
        <p className={`sc-note text-xs px-4 py-2 bg-slate-50 text-slate-500 border-b border-slate-100`}>
          {note}
        </p>
      )}

      <div className="sc-colhead grid grid-cols-[1fr_auto_auto] gap-3 px-4 py-1.5 bg-slate-50 border-b border-slate-100">
        <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest">操作</span>
        <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest w-28 text-center">Windows</span>
        <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest w-28 text-center">Mac</span>
      </div>

      <div className="divide-y divide-slate-50">
        {shortcuts.map((s, i) => (
          <div key={i} className="sc-row grid grid-cols-[1fr_auto_auto] gap-3 items-center px-4 py-2.5">
            <span className="text-sm text-slate-700">{s.action}</span>
            <Kbd>{s.win}</Kbd>
            <Kbd>{s.mac}</Kbd>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ShortcutsTab() {
  return (
    <>
      {/* 印刷専用スタイル: A4横向き1枚に収める */}
      <style>{`
        @media print {
          @page { size: A4 landscape; margin: 8mm 10mm; }

          #sc-root { gap: 3mm; }

          #sc-root .sc-print-btn { display: none; }

          #sc-root .sc-title { display: block !important; font-size: 10pt; font-weight: bold; margin-bottom: 2mm; }

          #sc-root .sc-banner { padding: 2mm 4mm; border-radius: 4mm; }
          #sc-root .sc-banner span { font-size: 7.5pt; }
          #sc-root .sc-banner .sc-kbd { font-size: 7pt; width: 20mm; padding: 0.3mm 1.5mm; }

          #sc-root .sc-grid { gap: 2.5mm; }

          #sc-root .sc-card { border-width: 1px; border-radius: 3mm; }
          #sc-root .sc-card-head { padding: 1.5mm 3mm; }
          #sc-root .sc-card-head h3 { font-size: 7.5pt; }
          #sc-root .sc-icon { font-size: 11pt; }

          #sc-root .sc-note { font-size: 6.5pt; padding: 1mm 3mm; }

          #sc-root .sc-colhead { padding: 0.8mm 3mm; }
          #sc-root .sc-colhead span { font-size: 6pt; }

          #sc-root .sc-row { padding: 1.2mm 3mm; gap: 2mm; }
          #sc-root .sc-row > span { font-size: 7.5pt; }

          #sc-root .sc-kbd { font-size: 6.5pt; width: 20mm; padding: 0.3mm 1mm; }
        }
      `}</style>

      <div id="sc-root" className="flex flex-col gap-6">
        {/* 印刷ボタン（画面のみ） */}
        <div className="sc-print-btn print:hidden flex justify-end">
          <button
            onClick={() => window.print()}
            className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 text-slate-600 rounded-xl text-sm font-medium hover:bg-slate-50 transition-colors shadow-card cursor-pointer"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
            印刷（A4横・1枚）
          </button>
        </div>

        {/* 印刷時のみ表示するタイトル */}
        <h1 className="sc-title hidden print:block text-xl font-bold text-gray-800 mb-2">
          Google Workspace ショートカット一覧
        </h1>

        {/* 共通ショートカット */}
        <div className="sc-banner flex items-center justify-between bg-white border border-slate-200 rounded-2xl px-5 py-3.5 gap-4 flex-wrap shadow-card">
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-semibold text-slate-700">共通</span>
            <span className="text-sm text-slate-500">— ショートカット一覧を表示</span>
          </div>
          <div className="flex items-center gap-3">
            <Kbd>Ctrl + /</Kbd>
            <Kbd>⌘ + /</Kbd>
          </div>
        </div>

        {/* ツール別カード */}
        <div className="sc-grid grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
          {TOOLS.map(t => <ToolCard key={t.tool} {...t} />)}
        </div>
      </div>
    </>
  );
}
